module.exports = __webpack_public_path__ + "img/csr_swiper_01_02.ff886903.jpg";